import React from "react";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import {
  Box,
  Card,
  Paper,
  MobileStepper,
  Grid,
  Button,
  Typography,
} from "@mui/material";
import HeadingComponent from "../../atom/Headings/Heading";
import { CircularWithValueLabel, CourseButton } from "../../atom";
import _ from "lodash";
import moment from "moment";
import { renderTruncatedText } from "../../../core/Constant";

const DashboardStudentCard = ({ list = [], onButtonClick = () => {} }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = list?.length;
  const visibleSteps = Math.min(maxSteps, 5);
  const indicatorStart = Math.min(
    Math.max(activeStep - visibleSteps + 1, 0),
    maxSteps - visibleSteps
  );

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Grid
      container
      flexDirection={"column"}
      alignItems={"center"}
      rowGap={{ xs: 2, sm: 4 }}
      sx={{
        width: "100%",
        minWidth: 0,
        minHeight: { xs: 420, sm: 460 },
        height: "100%",
        boxSizing: "border-box",
        p: { xs: 1, sm: 2 },
      }}
      flexWrap={'nowrap'}
      justifyContent={'center'}
    >
      <Grid item>
        <h3 style={{ fontWeight: 700,marginTop:2,color:"#9834F0"}}>Start Course</h3>
      </Grid>

      <Grid item sx={{ width: "100%" }}>
        <SwipeableViews
          axis={"x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          style={{
            // marginTop: 1,
            backgroundColor: "#ffffff",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          {list.map((item, index) => {
            return (
              <Grid
                key={item?.course_id ?? index}
                container
                flexDirection={"column"}
                alignItems={"center"}
                rowGap={1}
                sx={{ width: "100%", minWidth: 0, px: { xs: 0.5, sm: 1 } }}
              >
                <Grid item>
                  <p
                    style={{ textAlign: "center", maxWidth: "100%", overflowWrap: "anywhere", marginBottom:"0px" }}
                    className="dashboard-student-heading"
                  >
                    {renderTruncatedText(_.get(item, "course_name", ""), {limit : 30})}
                  </p>
                </Grid>
                <Grid item>
                  {
                    item?.student_batch_month && item?.student_batch_year && <span
                    style={{
                      textAlign: "center",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: 800,
                      fontSize: "15px",
                      color: "#2d3945",
                     }}
                  >
                     {
                     item?.student_batch_month ? moment()
                          .month(Number(item?.student_batch_month) - 1)
                          .format("MMMM") : ""
                   }{" "}
                   {item?.student_batch_year || ""}
                  </span>
                  }
                  
                </Grid>
                <Grid item>
                  <CircularWithValueLabel
                    text={_.get(item, "progress", 0) + "%"}
                    progress={_.get(item, "progress", 0)}
                  />
                </Grid>
                <Grid item sx={{ width: "100%" }}>
                  <CourseButton
                    onButtonClick={() => {
                      onButtonClick({
                        course_id: _.get(item, "course_id", ""),
                        is_registered: 1,
                        course: item,
                      });
                    }}
                    color={"#9834F0"}
                    text={"View Course"}
                  />
                </Grid>

              </Grid>
            );
          })}
        </SwipeableViews>
      </Grid>
      {maxSteps > 0 && (
                <Grid item sx={{ width: "100%" }}>
                  <MobileStepper
                    steps={visibleSteps}
                    position="static"
                    activeStep={activeStep - indicatorStart}
                    nextButton={
                      <Button
                        size="small"
                        onClick={handleNext}
                        disabled={activeStep === maxSteps - 1}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#ffffff !important",
                            color: "#28b882 !important",
                            boxShadow: "10px !important",
                          },
                        }}
                      >
                        {/* Next */}
                        {theme.direction === "rtl" ? (
                          <KeyboardArrowLeft />
                        ) : (
                          <KeyboardArrowRight />
                        )}
                      </Button>
                    }
                    backButton={
                      <Button
                        sx={{
                          "&:hover": {
                            backgroundColor: "#ffffff !important",
                            color: "#28b882 !important",
                            boxShadow: "10px !important",
                          },
                        }}
                        size="small"
                        onClick={handleBack}
                        disabled={activeStep === 0}
                      >
                        {theme.direction === "rtl" ? (
                          <KeyboardArrowRight />
                        ) : (
                          <KeyboardArrowLeft />
                        )}
                        {/* Back */}
                      </Button>
                    }
                  />
                </Grid>
                )}
    </Grid>
  );
};

export default DashboardStudentCard;
